/**
 * Part-to-whole in one bar.
 *
 * <p>The three code states are a progression, so the fills step light → dark rather
 * than taking unrelated hues. Segments are separated by a 2px gap in the surface
 * colour, not by a stroke — a stroke would add ink that is not data.
 *
 * <p>A segment is labelled inside itself only when the text actually fits; the legend
 * below carries every value regardless, so nothing is gated on a label that had no
 * room.
 */
const MIN_PERCENT_FOR_INLINE_LABEL = 12;

export default function StackBar({ segments, total }) {
  if (!total) {
    return <p className="muted small" style={{ margin: 0 }}>No codes have been generated yet.</p>;
  }

  const description = segments
    .map((segment) => `${segment.label}: ${segment.value.toLocaleString()}`)
    .join(', ');

  return (
    <>
      <div className="stack-bar" role="img" aria-label={description}>
        {segments
          .filter((segment) => segment.value > 0)
          .map((segment) => {
            const percent = (segment.value / total) * 100;
            return (
              <span
                className="stack-seg"
                key={segment.label}
                style={{ width: `${percent}%`, background: segment.color, color: segment.ink }}
              >
                {percent >= MIN_PERCENT_FOR_INLINE_LABEL ? `${Math.round(percent)}%` : ''}
              </span>
            );
          })}
      </div>
      <div className="stack-legend">
        {segments.map((segment) => (
          <span key={segment.label}>
            <span className="swatch" style={{ background: segment.color }} aria-hidden="true" />
            {segment.label} · <b>{segment.value.toLocaleString()}</b>
          </span>
        ))}
      </div>
    </>
  );
}
